function debounceBEC(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

class BECHeader extends HTMLElement {
  constructor() {
    super();
    this.visibleNav = this.querySelector('.visible-menu');
    this.hiddenNav = this.querySelector('.hidden-menu');
    this.more = this.querySelector('.more-button');
    this.icons = this.querySelector('.header__icons');
    this.logo = this.querySelector('.header__heading-link');

    this.priorityNavBreaks=[];
    this.priorityResizeNav();
    
    var debouncedResize = debounceBEC(this.priorityResizeNav, 20);
    window.addEventListener('resize', debouncedResize.bind(this));

    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));

  }

  priorityResizeNav() {
    var priorityNavSpace = document.body.offsetWidth - this.logo.offsetWidth - this.more.offsetWidth - this.icons.offsetWidth - parseFloat(getComputedStyle(this).paddingLeft)- parseFloat(getComputedStyle(this).paddingRight);
  
    // Hide items in More menu, visible list overflowing
    if(this.visibleNav.offsetWidth > priorityNavSpace){
      this.priorityNavBreaks.push(this.visibleNav.offsetWidth);
      this.hiddenNav.insertBefore(this.visibleNav.lastChild, this.hiddenNav.firstChild);
      this.more.classList.remove("more-button-hidden");
    } 
    // Add items to visible if some are hidden, and there is enough space
    else {
      if (priorityNavSpace > this.priorityNavBreaks[this.priorityNavBreaks.length-1]) {
        this.visibleNav.appendChild(this.hiddenNav.firstChild);
        this.priorityNavBreaks.pop();
      }
  
      // Hide More menu if there are no menu items
      if(this.hiddenNav.childElementCount<2){
        this.more.classList.add("more-button-hidden");
      }
    }

      this.closeSubMenus();
      this.openHiddenSubMenus();
    
    priorityNavSpace = document.body.offsetWidth - this.logo.offsetWidth - this.more.offsetWidth - this.icons.offsetWidth - parseFloat(getComputedStyle(this).paddingLeft)- parseFloat(getComputedStyle(this).paddingRight);
    
      if(this.visibleNav.offsetWidth > priorityNavSpace || priorityNavSpace > this.priorityNavBreaks[this.priorityNavBreaks.length-1]){
        this.priorityResizeNav();
      }
  }

  onSummaryClick(event){
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    this.closeSubMenus(detailsElement);
    this.openHiddenSubMenus();
    
  }

  openHiddenSubMenus() {
    for (const item of this.hiddenNav.querySelectorAll("details-disclosure>details")) {
      item.open = true;
    }
  }

  closeSubMenus(activeMenu){
    for (const item of this.querySelectorAll("details-disclosure>details")) {
      if (item!=activeMenu){
        item.open = false;
      }
    }
  }
}

customElements.define('bec-header', BECHeader);

document.querySelector(".header__icons-links .header__icon--search").addEventListener('click', function (){
  document.querySelector(".header__icons .header__search details").open = true;
  this.parentElement.parentElement.parentElement.open = false;
});

//Add on mouseout, close details?
// how to change to on hover?
// it seems like the onclick is automatic, in the browser, not set by javascript?!

// document.querySelectorAll('[id^="Details-HeaderMenu-"]').forEach((summary) => {  
// //   summary.addEventListener('mouseover', (event) => {
// //     event.currentTarget.parentElement.open = true});
    
//     summary.parentElement.parentElement.addEventListener('mouseout', (event) => {

//         event.currentTarget.querySelector("details").open = false;
//     })
// });

// on click of menu item, close all other menu items, then open current
// document.querySelectorAll('[id^="Details-HeaderMenu-"] summary').forEach((summary) => {  
    
//     summary.parentElement.addEventListener('click', (event) => {
//       document.querySelectorAll('[id^="Details-HeaderMenu-"]').forEach(el => {
// //         !event.currentTarget, el.open = false;
//         if (el != event.currentTarget){ 
//           el.open = false;
//         };
//       });
//       event.currentTarget.open = true;

//         event.currentTarget.querySelector("details").open = false;
//     })
// });

// close all menu items on scroll

// Wrap recent titles sections in a wrapper.
// function wrapSections(section_title) {
//   const childSections = document.querySelectorAll("."+section_title);
    
//   var wrapper = document.createElement('div');
//   wrapper.classList.add(section_title+"-wrapper");
//   childSections.item(0).parentNode.insertBefore(wrapper, childSections.item(0));

  
//   for ( var i=0; i< childSections.length; i++){
//     wrapper.appendChild(childSections.item(i));
//   }
  
//   wrapper.classList.add("page-width");
// }

// wrapSections("section-recent-titles");


class BECVariantSelects extends VariantSelects {
  constructor() {
    super();
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    
    const mediaGallery = this.closest('.product') ? this.closest('.product').querySelector('media-gallery, bec-media-gallery') : this.closest('.card').querySelector('media-gallery, bec-media-gallery');
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

  }

  updateVariantInput() {
    const productForm = this.closest('.product') ? this.closest('.product').querySelector('product-form') : this.closest('.card').querySelector('product-form');
    const input = productForm.querySelector('input[name="id"]');
    input.value = this.currentVariant.id;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

}

customElements.define('bec-variant-selects', BECVariantSelects);



// New js for grid items with add to cart for each item
class BECVariantRadios extends VariantRadios {
  constructor() {
    super();
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    
    const mediaGallery = this.closest('.product') ? this.closest('.product').querySelector('media-gallery, bec-media-gallery') : this.closest('.card').querySelector('media-gallery, bec-media-gallery');
    if ((this.closest('.card')) && this.closest('.card').contains(mediaGallery)) {
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.dataset.product}-${this.currentVariant.featured_media.id}`, true);
    }
    else {
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
    }
  }

  updateVariantInput() {
    const productForm = this.closest('.product') ? this.closest('.product').querySelector('product-form') : this.closest('.card').querySelector('product-form');
    const input = productForm.querySelector('input[name="id"]');
    input.value = this.currentVariant.id;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  renderProductInfo() {
    if (this.parentElement.classList.contains('card_product_variants')) {
      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}-${this.dataset.product}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}-${this.dataset.product}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
    }
    else {
      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const id = `price-${this.dataset.section}`;
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const destination = document.getElementById(id);
          const source = html.getElementById(id);
  
          if (source && destination) destination.innerHTML = source.innerHTML;
  
          const price = document.getElementById(`price-${this.dataset.section}`);
  
          if (price) price.classList.remove('visibility-hidden');
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        });
    }
  }

}

customElements.define('bec-variant-radios', BECVariantRadios);

class BECSlideshowComponent extends SlideshowComponent {
  constructor() {
    super();
    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide:not(.buffer)');
    // if (this.sliderItemsToShow.length > 0) this.currentPage = 2;
  }

  initPages() {
    this.slider.scrollTo({
      left: this.slider.scrollLeft + (1 * this.sliderItemOffset)
    });
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0 && !element.classList.contains('buffer'));
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    super.update();
    this.sliderItemsToShow.forEach(element => {
      element.classList.remove('focused-slide');
    });
    this.sliderItemsToShow[this.currentPage - 1].classList.add('focused-slide');

    this.prevButton.removeAttribute('disabled');
    this.nextButton.removeAttribute('disabled');
  }
}

customElements.define('bec-slideshow-component', BECSlideshowComponent);

class BECSubmissionsForms extends HTMLElement {
  constructor() {
    super();

    this.forms = this.querySelectorAll(".submissions-forms__submissions-form");
    this.headings = this.querySelectorAll(".submissions-forms__form-heading");

    this.headings.forEach(form => form.addEventListener('click', this.onButtonClick.bind(this)));
  }

  onButtonClick(event) {
    event.preventDefault();
    // hide form unless current target
    for ( let i = 0; i < this.forms.length; i++ ) {
      if ( this.headings[i] == event.currentTarget ){
        this.headings[i].classList.add('active');
        this.forms[i].classList.add('active');
      }
      else {
        this.headings[i].classList.remove('active');
        this.forms[i].classList.remove('active');
      }
    } 
  }
}

customElements.define('submissions-forms', BECSubmissionsForms);